import * as React from 'react'
import './PortalFooter.scss'

export const NewFooter = () => {
  
     const year = new Date().getFullYear();
  return (

    <footer className="portal-footer">
      <div className="portal-footer__inner">
        {/* TOPPDEL – LOGO + KOLUMNER */}
        <div className="portal-footer__top">
          {/* LOGO */}
          <div className="portal-footer__logo-wrapper">
            <a href="/" aria-label="Gå till startsidan" className="portal-footer__logo-link">
              {/* Klistra in din fulla inline-SVG här */}
              <svg
                className="portal-footer__logo"
                xmlns="http://www.w3.org/2000/svg"
                width="87"
                height="30"
                viewBox="0 0 87 30"
                fill="white"
              >
                 <svg version="1.1" className='portal-footer__logo' width={'87'} height={'30'} id="logo" xmlns="http://www.w3.org/2000/svg"  x="0px" y="0px"
	 viewBox="0 0 578.9 200" >

<g>
	<path id="a" className="st0" d="M568.8,120.7c-6.7-6.2-16.2-9.3-28.5-9.3c-9.5,0-18.4,1.5-26.7,4.6v13.5c8.6-2.9,16.8-4.3,24.5-4.3
		c8.5,0,14.5,1.6,18.2,4.7c3.7,3.1,5.7,8.3,6.1,15.6c-5.2-0.7-10.5-1-16-1c-13,0-23.2,2.4-30.5,7.2c-7.4,4.8-11.1,11.4-11.1,19.9
		c0,1.9,0.2,3.7,0.5,5.7c0.3,1.9,1.3,4.3,2.7,7.3c1.5,2.9,3.4,5.5,5.9,7.6c2.5,2.1,6.2,4,11.1,5.6c4.9,1.6,10.6,2.4,17.1,2.4
		c6.4,0,12-0.8,16.8-2.3c4.9-1.5,8.5-3.4,10.9-5.5c2.4-2.1,4.4-4.6,5.8-7.5c1.4-2.9,2.3-5.2,2.7-7c0.4-1.8,0.6-3.7,0.6-5.5v-24.8
		C578.9,135.7,575.5,126.9,568.8,120.7z M562.4,172.7c0,9-6.7,13.6-20,13.6h-0.3c-14.2,0-21.2-4.7-21.2-14.1c0-2.8,1-5.1,2.9-7.1
		c2-2,4.4-3.4,7.4-4.3c3-0.9,5.8-1.5,8.4-1.9c2.6-0.4,5.1-0.6,7.4-0.6c6,0.1,11.1,0.4,15.4,1.1V172.7z"/>
	<path id="r" className="st0" d="M447.8,116.6c-5.3,1.5-9,4.5-9,8.1v0.3l0,75H455c0,0,0-52.4,0-65.3c0-4.1,1.3-5.9,4.8-6.9
		c0.6-0.1,1.3-0.3,1.9-0.4c0.1,0,0.2,0,0.3,0c6.7-1.3,13.3-1.9,19.9-2v-14.1C470.8,111.3,459.4,113.1,447.8,116.6
		C447.8,116.6,447.8,116.6,447.8,116.6z"/>
	<path id="f" className="st0" d="M375.6,120.1v2.8h-11.2V136h11.2v64h17.2v-64H414V123h-21.3v-2.5c0-15.7,12-17.7,18.8-17.7
		c2.7,0,4.4,0.3,4.4,0.3V89.2c0,0-2.7-0.5-6.6-0.5C398,88.7,375.6,92.2,375.6,120.1z"/>
	<path id="n" className="st0" d="M326.6,119.6c-6.3-5.5-15.1-8.3-26.3-8.3c-12.8,0-25.4,2.9-37.7,8.6V200h16.2v-71.6
		c6.6-2,13.6-3,20.8-3c8,0,13.4,1.4,16,4.3c2.7,2.8,4,6.7,4,11.6V200h16.5v-57.5C336.1,132.7,332.9,125.1,326.6,119.6z"/>
	<path id="i" className="st0" d="M223.4,182.4V122c0-7.5-3.4-10.7-11.3-10.7h-9.7v13.9h0.1c2.5,0,3.9,1.2,3.9,3.7v60.4
		c0,7.5,3.4,10.7,11.3,10.7h9.7v-13.9h-0.1C224.9,186.1,223.4,184.9,223.4,182.4z"/>
	<path id="s" className="st0" d="M128.9,135.8c0-7.4,7.3-10.4,14.7-10.4c14.2,0,22.1,7.5,22.1,7.5l6.9-12.2c0,0-9.2-9.4-28.9-9.4
		c-17.9,0-32.4,8.7-32.4,24.1c0,27.6,46,24.4,46,40c0,6.9-7.4,10.5-14.9,10.5c-15.6,0-25.7-9.9-25.7-9.9l-8.3,11.5
		c0,0,12,12.4,34,12.4c19.7,0,32.4-10.5,32.4-24.6C174.9,147.6,128.9,151,128.9,135.8z"/>
	<g id="symbol_00000138574764605648512230000000382262359306567607_">
		<path className="st0" d="M0,155.7V200h44.3c20.3,0,37.5-13.8,42.7-32.5c0.9-3.1,1.4-6.3,1.6-9.6c0-0.8,0.1-1.5,0.1-2.3v-44.3H44.3
			C19.9,111.3,0,131.3,0,155.7z"/>
		<path className="st0" d="M111.3,44.3v44.3h44.3c20.3,0,37.5-13.8,42.7-32.5c0.9-3.1,1.4-6.3,1.6-9.6c0-0.8,0.1-1.5,0.1-2.3V0h-44.3
			C131.3,0,111.3,20,111.3,44.3z"/>
		<path className="st0" d="M88.7,44.3v44.3H44.3C24,88.7,6.8,74.8,1.6,56.2c-0.9-3.1-1.4-6.3-1.6-9.6C0,45.9,0,45.1,0,44.3L0,0l44.3,0
			C68.7,0,88.7,20,88.7,44.3z"/>
	</g>
</g>
</svg>
              </svg>
            </a>
          </div>

          {/* KOLUMNER */}
          <div className="portal-footer__columns">
            {/* Kontakta oss */}
            <section className="portal-footer__column portal-footer__column--contact">
              <p className="portal-footer__heading">Kontakta oss</p>
              <p className="portal-footer__text">
                Kungsbroplan 2
                <br />
                Box 1026 <br/>101 38 Stockholm 
                <br />
                <br />
                08–525 099 40
                <br />
                <br />
                <strong>Öppettider</strong>
                <br />
                Vardagar 8:00 – 16:30
              </p>
            </section>

            {/* Genvägar */}
            <nav
              className="portal-footer__column portal-footer__column--links"
              aria-label="Genvägar"
            >
              <p className="portal-footer__heading">Genvägar</p>
              <ul className="portal-footer__link-list">
                <li>
                  <a href="https://sinfra.euwest01.umbraco.io/om-oss/" className="portal-footer__link" target='_blank' rel='noreferrer'>
                    Om oss
                  </a>
                </li>
                <li>
                  <a href="https://sinfra.euwest01.umbraco.io/om-oss/fragor-och-svar/" className="portal-footer__link" target='_blank' rel='noreferrer'>
                    Frågor och svar
                  </a>
                </li>
                <li>
                  <a href="https://app.bwz.se/sinfra/b/v?subscribeto=3&ucrc=F6A6AC1025" className="portal-footer__link" target='_blank' rel='noreferrer'>
                    Prenumerera på vårt nyhetsbrev
                  </a>
                </li>
                <li>
                  <a href="https://sinfra.euwest01.umbraco.io/om-oss/jobba-hos-oss/" className="portal-footer__link" target='_blank' rel='noreferrer'>
                    Jobba hos oss
                  </a>
                </li>
                <li>
                  <a href="https://sinfra.euwest01.umbraco.io/om-oss/personuppgifter/" className="portal-footer__link" target='_blank' rel='noreferrer'>
                    Personuppgifter
                  </a>
                </li>
                
              </ul>
            </nav>

            {/* Om oss + LinkedIn */}
            <section className="portal-footer__column portal-footer__column--about">
              <p className="portal-footer__heading">Om oss</p>
              <p className="portal-footer__text">
                Sinfra gör hållbara inköp enkelt. Med ramavtal och inköpsresurser skapar vi
                trygghet, effektivitet och värde för våra medlemmar inom
                samhällsinfrastruktur. Vi är mer än en inköpscentral – vi är en strategisk
                partner som hjälper branschen att skapa ett hållbart samhälle.
              </p>

              <div className="portal-footer__social">
                <a
                  href="https://www.linkedin.com/company/17890267/"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="Besök Sinfras LinkedIn-sida"
                  className="portal-footer__social-link"
                >
                  <svg
                    className="portal-footer__social-icon"
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                  >
                    <path
                      d="M-0.00976562 4.66667H3.32357V16H-0.00976562V4.66667ZM1.6469 3.33333H1.62823C0.633568 3.33333 -0.00976562 2.592 -0.00976562 1.666C-0.00976562 0.72 0.653568 0 1.66623 0C2.68023 0 3.3049 0.72 3.32357 1.666C3.32357 2.59133 2.68023 3.33333 1.6469 3.33333ZM15.9902 16H12.6569V9.934C12.6569 8.46867 11.8402 7.46867 10.5289 7.46867C9.52824 7.46867 8.9869 8.14333 8.72423 8.79533C8.62823 9.02867 8.6569 9.674 8.6569 10V16H5.32357V4.66667H8.6569V6.41067C9.13757 5.66667 9.89023 4.66667 11.8156 4.66667C14.2009 4.66667 15.9896 6.16667 15.9896 9.516L15.9902 16Z"
                      fill="white"
                    />
                  </svg>
                </a>
              </div>
            </section>
          </div>
        </div>

        {/* DIVIDER */}
        <hr className="portal-footer__divider" />

        {/* BOTTENRAD */}
        <div className="portal-footer__bottom">
          {/* <div className="portal-footer__bottom-links">
            <a href="/startsida/" className="portal-footer__bottom-link">
              Hantera cookies
            </a>
            <span className="portal-footer__bottom-separator">|</span>
            <a href="/om-oss/personuppgifter/" className="portal-footer__bottom-link">
              Behandling av personuppgifter
            </a>
            <span className="portal-footer__bottom-separator">|</span>
            <a href="/startsida/" className="portal-footer__bottom-link">
              Dataskyddsombud
            </a>
          </div> */}

          <p className="portal-footer__copyright">
            Copyright © Sinfra {year}. Alla rättigheter förbehålls.
          </p>
        </div>
      </div>
    </footer>
    
  );
}